var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon == 'slides')?_c('img',{attrs:{"alt":"","src":require("./assets/slides_icon.svg")}}):_vm._e(),_c('button',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }